import * as React from "react";
import {ISvgIconProps, SvgIcon} from '../../../basic-ui-components/icon/svg-icon/svg.icon';

export class LeaveIcon extends React.Component<ISvgIconProps> {
    render() {
        return (
            <SvgIcon {...this.props} fill="none">
                <g stroke="currentColor" stroke-width="1.3" stroke-linecap="square">
                    <path d="M15.973 18.375v2.813c0 1.035 -0.839 1.875 -1.873 1.875H2.809c-1.035 0 -1.873 -0.84 -1.873 -1.875V2.812c0 -1.035 0.839 -1.875 1.873 -1.875h11.291c1.035 0 1.873 0.84 1.873 1.875v2.813" stroke-miterlimit="13.33"/>
                    <path d="M21.924 11.999H9.227" stroke-linejoin="round"/>
                    <path d="M19.581 8.907 22.673 12l-3.092 3.093" stroke-miterlimit="13.33"/>
                </g>
            </SvgIcon>
        );
    }
}
